//import React, { useContext } from 'react';
import { PageHeader, Page, PageContent, Heading, Box, Text } from 'grommet';
import { DashboardGridProd, DashboardGridITG, AppFooter } from '.';

export const Home = () => {
  //const [user, setUser] = useState(defaultUser);
  //const size = useContext(ResponsiveContext);

  return (
    <Page flex="grow" background="background-back">

      <Box background="url('images/satin-3.jpg')" height="200px"  margin={{ top: 'none' }}>
        <Box margin={{ top: 'none', left: 'large' }}>
          <PageHeader pad={{ top: '15px', bottom: '15px' }} 
                      title={<Text color="white" size="xxlarge" weight="bolder" style={{fontWeight: 'bold'}}>Welcome to the Status Central Community</Text>} 
                      subtitle={'Your one stop shop for all things HPE IT status.'}
                      style={{ color: 'white' }}
                      size='medium'/>
        </Box>
      </Box>

      <PageContent flex="grow"> 

          <Heading size="small" weight="bold" margin={{ top: 'large' }}>Production Pages:</Heading>

          <DashboardGridProd /> 

          <Heading size="small" weight="bold" margin={{ top: 'large' }}>ITG Test Pages:</Heading>

          <DashboardGridITG /> 

      </PageContent> 

      <AppFooter/>

    </Page>
  );
};